import { Component, OnInit, EventEmitter, Output, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Observable, Subscription } from 'rxjs';
import { GruaTecnicsFilter } from '../../models/grua-tecnics-filter';

@Component({
  selector: 'app-grua-tecnics-filter',
  templateUrl: './grua-tecnics-filter.component.html',
  styleUrls: ['./grua-tecnics-filter.component.scss']
})
export class GruaTecnicsFilterComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  filter: GruaTecnicsFilter;

  @Output() notify: EventEmitter<GruaTecnicsFilter> = new EventEmitter<GruaTecnicsFilter>();

  constructor(
    public thisDialogRef: MatDialogRef<GruaTecnicsFilterComponent>,
    private i18n: I18n,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.filter = data.filter;
  }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }

}
